module.exports = __webpack_public_path__ + "flowdock-logo.png";